// requestAnimationFrame is actually quite expensive. We call it twice for each violin
// (once from Violin.tsx and once from ViolinChart.tsx), and it used to take 10% of our
// run time each frame. Instead, this wrapper keeps its own queue of callbacks and
// schedules a rAF callback only once each frame.

export interface RequestAnimationFrameQueue {
  (f: () => void): undefined | number;
  cancel(f: () => void): void;
}

export const newRequestAnimationFrameQueue = (): RequestAnimationFrameQueue => {
  let queue: Array<() => void> = [];
  let rafId: undefined | number;

  const rafCallback = () => {
    rafId = undefined;
    queue.forEach((f) => {
      f();
    });
    queue = [];
  };

  const raf = (f: () => void) => {
    queue.push(f);
    if (rafId === undefined) {
      rafId = window.requestAnimationFrame(rafCallback);
    }

    return rafId;
  };

  (raf as any).cancel = (f: () => void) => {
    queue = queue.filter((x) => x !== f);
  };

  return raf as RequestAnimationFrameQueue;
};
